/**
 * User-spezifische API-Funktionen
 * Benutzer-Verwaltung
 */
import { api } from "./client";

export interface OrgUser {
  user_id: string;
  email: string;
  name: string;
  picture?: string;
}

export const usersApi = {
  async getCurrentUser(): Promise<any> {
    return api.get("/users/me");
  },

  async getOrgUsers(): Promise<OrgUser[]> {
    return api.get("/users");
  },

  async updateUser(userId: string, userData: any): Promise<any> {
    return api.put(`/users/${userId}`, userData);
  },
};

/** Eine Gesellschaft des Mandanten als Auswahlwert für Antragskontakte */
export interface GesellschaftOption {
  id: string;
  name: string;
  rechtsform?: string | null;
  typ: string;
}

export const organisationsApi = {
  /** Gesellschaften der eigenen Organisation – ohne Admin-Recht lesbar. */
  async getEigeneGesellschaften(): Promise<GesellschaftOption[]> {
    return api.get("/organisations/eigene/gesellschaften");
  },
};
